// extracted by mini-css-extract-plugin
export var closeButton = "_fr-2";
export var closeButtonIcon = "_fr-3";
export var lightboxContent = "_fr-1";
export var lightboxOverlay = "_fr-0";